import urlApi from './urlApi';
import { getLongReadPosts } from './getLongReadPosts';
export var ADD_LR_POST_REQUEST = 'ADD_LR_POST_REQUEST';
export var ADD_LR_POST_SUCCESS = 'ADD_LR_POST_SUCCESS';
export var ADD_LR_POST_ERROR = 'ADD_LR_POST_ERROR';
export var ADD_LR_POST_TIMEOUT_START = 'ADD_LR_POST_TIMEOUT_START';
export var ADD_MANY_LR_POST_TIMEOUT_START = 'ADD_MANY_LR_POST_TIMEOUT_START';
export var ADD_LR_POST_TIMEOUT_END = 'ADD_LR_POST_TIMEOUT_END';
export var ADD_MANY_LR_POST_TIMEOUT_END = 'ADD_MANY_LR_POST_TIMEOUT_END';
export function addLongReadPost(args) {
    var id = args.id, title = args.title, text = args.text, color = args.color, imageid = args.imageid, lgid = args.lgid, isFL = args.isFL, imgCaption = args.imgCaption, style = args.style, num = args.num, imageData = args.imageData, thematic = args.thematic, titlePosition = args.titlePosition, projectIds = args.projectIds, onAfterLoad = args.onAfterLoad, formId = args.formId, formPosition = args.formPosition, anchorText = args.anchorText, buttons = args.buttons, additionalInfo = args.additionalInfo, generalProps = args.generalProps, useRating = args.useRating, ratings = args.ratings, reverseParam = args.reverseParam, caption = args.caption;
    return function (dispatch) {
        dispatch({
            type: ADD_LR_POST_REQUEST,
            payload: {
                lgId: lgid
            }
        });
        var onSubmit = function (res) {
            dispatch({
                type: ADD_LR_POST_SUCCESS,
                payload: {
                    data: res,
                    lgId: lgid
                }
            });
            // отображение поста при загрузке
            onAfterLoad(true);
            var longReadLoadingPost;
            if (imageid === '') {
                longReadLoadingPost = {
                    postId: 'loading',
                    useRating: useRating,
                    userId: id,
                    longreadId: lgid,
                    style: style,
                    additionalInfo: additionalInfo,
                    isFirstLetter: false,
                    title: title,
                    titlePosition: titlePosition,
                    text: text,
                    localization: null,
                    color: color,
                    isHidden: true,
                    isDeleted: true,
                    attachments: [],
                    dateCreate: '2021-05-12T10:01:17.594Z',
                    dateLastChange: '2021-05-12T10:01:17.594Z',
                    like: 0,
                    position: num - 1,
                    leagueItem: null,
                    citiesBlock: null,
                    orderList: null,
                    historyList: null,
                    geozoneBlock: null,
                    specBlock: null,
                    ratings: ratings
                };
            }
            else {
                longReadLoadingPost = {
                    postId: 'loading',
                    useRating: useRating,
                    userId: id,
                    longreadId: lgid,
                    style: style,
                    additionalInfo: additionalInfo,
                    isFirstLetter: false,
                    title: '',
                    titlePosition: titlePosition,
                    text: text,
                    localization: null,
                    color: color,
                    isHidden: true,
                    isDeleted: true,
                    attachments: [
                        {
                            postAttachmentId: '',
                            type: 0,
                            referenceId: '',
                            text: 'string',
                            description: imgCaption,
                            texts: null,
                            descriptions: null,
                            isDeleted: true,
                            file: {
                                fileId: 'loading',
                                containerId: null,
                                isDeleted: false,
                                isNew: false,
                                inProgress: false,
                                type: 'cardimages',
                                url: imageData,
                                size: null,
                                crop: null,
                                localization: 'global'
                            }
                        }
                    ],
                    dateCreate: null,
                    dateLastChange: null,
                    like: 0,
                    position: num - 1,
                    leagueItem: null,
                    citiesBlock: null,
                    orderList: null,
                    historyList: null,
                    geozoneBlock: null,
                    specBlock: null,
                    ratings: ratings
                };
            }
            var userid = localStorage.getItem('userId');
            (generalProps === null || generalProps === void 0 ? void 0 : generalProps.performerByEventOrByTimeout) && generalProps.performerByEventOrByTimeout(function () {
                var _a;
                getLongReadPosts(userid, lgid, ((_a = generalProps === null || generalProps === void 0 ? void 0 : generalProps.commonProps) === null || _a === void 0 ? void 0 : _a.sign) || '', thematic)(dispatch);
                dispatch({
                    type: ADD_LR_POST_TIMEOUT_END,
                    payload: {
                        data: null,
                        lgId: lgid
                    }
                });
            }, res, 5000);
            dispatch({
                type: ADD_LR_POST_TIMEOUT_START,
                payload: {
                    data: [longReadLoadingPost],
                    lgId: lgid,
                    reverseParam: reverseParam
                }
            });
        };
        var onError = function (err) {
            dispatch({
                type: ADD_LR_POST_ERROR,
                payload: {
                    lgId: lgid
                }
            });
        };
        urlApi()
            .addLongReadPost(args, onSubmit, onError);
    };
}
export function addManyLongReadPost(imageList, id, lgid, isFL, title, text, color, num, thematic, onAfterLoad, style, caption, titlePosition, anchorText, generalProps, useRating, isRibbon, reverseParam, additionalInfo) {
    return function (dispatch) {
        dispatch({
            type: ADD_LR_POST_REQUEST,
            payload: {
                lgId: lgid
            }
        });
        var onSubmit = function (res) {
            dispatch({
                type: ADD_LR_POST_SUCCESS,
                payload: {
                    data: res,
                    lgId: lgid
                }
            });
            var isSPvotePost = ['super-puper-vote', 'slider', 'two_pictures', 'tile'].includes(style);
            var longReadLoadingPosts;
            // Успешная загрузка для кнопки POST
            onAfterLoad(true);
            // отображение поста при загрузке
            if (isSPvotePost) {
                longReadLoadingPosts = [{
                        // eslint-disable-next-line prettier/prettier
                        postId: "loading",
                        userId: id,
                        longreadId: lgid,
                        style: style,
                        isFirstLetter: false,
                        title: '',
                        titlePosition: titlePosition,
                        text: '',
                        localization: null,
                        color: '',
                        isHidden: true,
                        isDeleted: true,
                        attachments: imageList === null || imageList === void 0 ? void 0 : imageList.map(function (img, idx) { return ({
                            postAttachmentId: '',
                            type: 0,
                            referenceId: '',
                            text: img === null || img === void 0 ? void 0 : img.text,
                            description: img === null || img === void 0 ? void 0 : img.caption,
                            texts: null,
                            descriptions: null,
                            isDeleted: true,
                            file: {
                                fileId: 'loading',
                                containerId: null,
                                isDeleted: false,
                                isNew: false,
                                inProgress: false,
                                type: 'cardimages',
                                url: img === null || img === void 0 ? void 0 : img.src,
                                size: null,
                                crop: null,
                                localization: 'global'
                            }
                        }); }),
                        dateCreate: null,
                        dateLastChange: null,
                        like: 0,
                        position: num - 1,
                        leagueItem: null,
                        citiesBlock: null,
                        orderList: null,
                        historyList: null,
                        geozoneBlock: null,
                        specBlock: null,
                        useRating: useRating,
                        isRibbon: isRibbon,
                        additionalInfo: additionalInfo
                    }];
            }
            else {
                longReadLoadingPosts = imageList === null || imageList === void 0 ? void 0 : imageList.map(function (img, idx) { return ({
                    // eslint-disable-next-line prettier/prettier
                    postId: "loading_".concat(idx),
                    userId: id,
                    longreadId: lgid,
                    style: 'big',
                    isFirstLetter: false,
                    titlePosition: titlePosition,
                    title: '',
                    text: img === null || img === void 0 ? void 0 : img.text,
                    localization: null,
                    color: img === null || img === void 0 ? void 0 : img.color,
                    isHidden: true,
                    isDeleted: true,
                    attachments: [
                        {
                            postAttachmentId: '',
                            type: 0,
                            referenceId: '',
                            text: 'string',
                            description: img === null || img === void 0 ? void 0 : img.caption,
                            texts: null,
                            descriptions: null,
                            isDeleted: true,
                            file: {
                                fileId: 'loading',
                                containerId: null,
                                isDeleted: false,
                                isNew: false,
                                inProgress: false,
                                type: 'cardimages',
                                url: img === null || img === void 0 ? void 0 : img.src,
                                size: null,
                                crop: null,
                                localization: 'global'
                            }
                        }
                    ],
                    dateCreate: null,
                    dateLastChange: null,
                    like: 0,
                    position: num - 1,
                    leagueItem: null,
                    citiesBlock: null,
                    orderList: null,
                    historyList: null,
                    geozoneBlock: null,
                    specBlock: null,
                    useRating: useRating,
                    isRibbon: isRibbon
                }); });
            }
            var userid = localStorage.getItem('userId');
            dispatch({
                type: ADD_MANY_LR_POST_TIMEOUT_START,
                payload: {
                    data: longReadLoadingPosts,
                    lgId: lgid,
                    reverseParam: reverseParam
                }
            });
            (generalProps === null || generalProps === void 0 ? void 0 : generalProps.performerByEventOrByTimeout) && generalProps.performerByEventOrByTimeout(function () {
                var _a;
                getLongReadPosts(userid, lgid, ((_a = generalProps === null || generalProps === void 0 ? void 0 : generalProps.commonProps) === null || _a === void 0 ? void 0 : _a.sign) || '', thematic)(dispatch);
                dispatch({
                    type: ADD_MANY_LR_POST_TIMEOUT_END,
                    payload: {
                        data: null,
                        lgId: lgid
                    }
                });
            }, res, 8000);
        };
        var onError = function (err) {
            dispatch({
                type: ADD_LR_POST_ERROR,
                payload: {
                    lgId: lgid
                }
            });
        };
        urlApi()
            .addManyLongReadPost(imageList, id, lgid, isFL, title, text, color, num, thematic, onAfterLoad, style, caption, titlePosition, anchorText, useRating, onSubmit, onError, isRibbon, additionalInfo);
    };
}
//# sourceMappingURL=addLongReadPost.js.mapimport urlApi from './urlApi';
import { getLongReadPosts } from './getLongReadPosts';
export var ADD_LR_POST_REQUEST = 'ADD_LR_POST_REQUEST';
export var ADD_LR_POST_SUCCESS = 'ADD_LR_POST_SUCCESS';
export var ADD_LR_POST_ERROR = 'ADD_LR_POST_ERROR';
export var ADD_LR_POST_TIMEOUT_START = 'ADD_LR_POST_TIMEOUT_START';
export var ADD_MANY_LR_POST_TIMEOUT_START = 'ADD_MANY_LR_POST_TIMEOUT_START';
export var ADD_LR_POST_TIMEOUT_END = 'ADD_LR_POST_TIMEOUT_END';
export var ADD_MANY_LR_POST_TIMEOUT_END = 'ADD_MANY_LR_POST_TIMEOUT_END';
export function addLongReadPost(args) {
    var id = args.id, title = args.title, text = args.text, color = args.color, imageid = args.imageid, lgid = args.lgid, isFL = args.isFL, imgCaption = args.imgCaption, style = args.style, num = args.num, imageData = args.imageData, thematic = args.thematic, titlePosition = args.titlePosition, projectIds = args.projectIds, onAfterLoad = args.onAfterLoad, formId = args.formId, formPosition = args.formPosition, anchorText = args.anchorText, buttons = args.buttons, additionalInfo = args.additionalInfo, generalProps = args.generalProps, useRating = args.useRating, ratings = args.ratings, reverseParam = args.reverseParam, caption = args.caption;
    return function (dispatch) {
        dispatch({
            type: ADD_LR_POST_REQUEST,
            payload: {
                lgId: lgid
            }
        });
        var onSubmit = function (res) {
            dispatch({
                type: ADD_LR_POST_SUCCESS,
                payload: {
                    data: res,
                    lgId: lgid
                }
            });
            // отображение поста при загрузке
            onAfterLoad(true);
            var longReadLoadingPost;
            if (imageid === '') {
                longReadLoadingPost = {
                    postId: 'loading',
                    useRating: useRating,
                    userId: id,
                    longreadId: lgid,
                    style: style,
                    additionalInfo: additionalInfo,
                    isFirstLetter: false,
                    title: title,
                    titlePosition: titlePosition,
                    text: text,
                    localization: null,
                    color: color,
                    isHidden: true,
                    isDeleted: true,
                    attachments: [],
                    dateCreate: '2021-05-12T10:01:17.594Z',
                    dateLastChange: '2021-05-12T10:01:17.594Z',
                    like: 0,
                    position: num - 1,
                    leagueItem: null,
                    citiesBlock: null,
                    orderList: null,
                    historyList: null,
                    geozoneBlock: null,
                    specBlock: null,
                    ratings: ratings
                };
            }
            else {
                longReadLoadingPost = {
                    postId: 'loading',
                    useRating: useRating,
                    userId: id,
                    longreadId: lgid,
                    style: style,
                    additionalInfo: additionalInfo,
                    isFirstLetter: false,
                    title: '',
                    titlePosition: titlePosition,
                    text: text,
                    localization: null,
                    color: color,
                    isHidden: true,
                    isDeleted: true,
                    attachments: [
                        {
                            postAttachmentId: '',
                            type: 0,
                            referenceId: '',
                            text: 'string',
                            description: imgCaption,
                            texts: null,
                            descriptions: null,
                            isDeleted: true,
                            file: {
                                fileId: 'loading',
                                containerId: null,
                                isDeleted: false,
                                isNew: false,
                                inProgress: false,
                                type: 'cardimages',
                                url: imageData,
                                size: null,
                                crop: null,
                                localization: 'global'
                            }
                        }
                    ],
                    dateCreate: null,
                    dateLastChange: null,
                    like: 0,
                    position: num - 1,
                    leagueItem: null,
                    citiesBlock: null,
                    orderList: null,
                    historyList: null,
                    geozoneBlock: null,
                    specBlock: null,
                    ratings: ratings
                };
            }
            var userid = localStorage.getItem('userId');
            (generalProps === null || generalProps === void 0 ? void 0 : generalProps.performerByEventOrByTimeout) && generalProps.performerByEventOrByTimeout(function () {
                var _a;
                getLongReadPosts(userid, lgid, ((_a = generalProps === null || generalProps === void 0 ? void 0 : generalProps.commonProps) === null || _a === void 0 ? void 0 : _a.sign) || '', thematic)(dispatch);
                dispatch({
                    type: ADD_LR_POST_TIMEOUT_END,
                    payload: {
                        data: null,
                        lgId: lgid
                    }
                });
            }, res, 5000);
            dispatch({
                type: ADD_LR_POST_TIMEOUT_START,
                payload: {
                    data: [longReadLoadingPost],
                    lgId: lgid,
                    reverseParam: reverseParam
                }
            });
        };
        var onError = function (err) {
            dispatch({
                type: ADD_LR_POST_ERROR,
                payload: {
                    lgId: lgid
                }
            });
        };
        urlApi()
            .addLongReadPost(args, onSubmit, onError);
    };
}
export function addManyLongReadPost(imageList, id, lgid, isFL, title, text, color, num, thematic, onAfterLoad, style, caption, titlePosition, anchorText, generalProps, useRating, isRibbon, reverseParam, additionalInfo) {
    return function (dispatch) {
        dispatch({
            type: ADD_LR_POST_REQUEST,
            payload: {
                lgId: lgid
            }
        });
        var onSubmit = function (res) {
            dispatch({
                type: ADD_LR_POST_SUCCESS,
                payload: {
                    data: res,
                    lgId: lgid
                }
            });
            var isSPvotePost = ['super-puper-vote', 'slider', 'two_pictures', 'tile'].includes(style);
            var longReadLoadingPosts;
            // Успешная загрузка для кнопки POST
            onAfterLoad(true);
            // отображение поста при загрузке
            if (isSPvotePost) {
                longReadLoadingPosts = [{
                        // eslint-disable-next-line prettier/prettier
                        postId: "loading",
                        userId: id,
                        longreadId: lgid,
                        style: style,
                        isFirstLetter: false,
                        title: '',
                        titlePosition: titlePosition,
                        text: '',
                        localization: null,
                        color: '',
                        isHidden: true,
                        isDeleted: true,
                        attachments: imageList === null || imageList === void 0 ? void 0 : imageList.map(function (img, idx) { return ({
                            postAttachmentId: '',
                            type: 0,
                            referenceId: '',
                            text: img === null || img === void 0 ? void 0 : img.text,
                            description: img === null || img === void 0 ? void 0 : img.caption,
                            texts: null,
                            descriptions: null,
                            isDeleted: true,
                            file: {
                                fileId: 'loading',
                                containerId: null,
                                isDeleted: false,
                                isNew: false,
                                inProgress: false,
                                type: 'cardimages',
                                url: img === null || img === void 0 ? void 0 : img.src,
                                size: null,
                                crop: null,
                                localization: 'global'
                            }
                        }); }),
                        dateCreate: null,
                        dateLastChange: null,
                        like: 0,
                        position: num - 1,
                        leagueItem: null,
                        citiesBlock: null,
                        orderList: null,
                        historyList: null,
                        geozoneBlock: null,
                        specBlock: null,
                        useRating: useRating,
                        isRibbon: isRibbon,
                        additionalInfo: additionalInfo
                    }];
            }
            else {
                longReadLoadingPosts = imageList === null || imageList === void 0 ? void 0 : imageList.map(function (img, idx) { return ({
                    // eslint-disable-next-line prettier/prettier
                    postId: "loading_".concat(idx),
                    userId: id,
                    longreadId: lgid,
                    style: 'big',
                    isFirstLetter: false,
                    titlePosition: titlePosition,
                    title: '',
                    text: img === null || img === void 0 ? void 0 : img.text,
                    localization: null,
                    color: img === null || img === void 0 ? void 0 : img.color,
                    isHidden: true,
                    isDeleted: true,
                    attachments: [
                        {
                            postAttachmentId: '',
                            type: 0,
                            referenceId: '',
                            text: 'string',
                            description: img === null || img === void 0 ? void 0 : img.caption,
                            texts: null,
                            descriptions: null,
                            isDeleted: true,
                            file: {
                                fileId: 'loading',
                                containerId: null,
                                isDeleted: false,
                                isNew: false,
                                inProgress: false,
                                type: 'cardimages',
                                url: img === null || img === void 0 ? void 0 : img.src,
                                size: null,
                                crop: null,
                                localization: 'global'
                            }
                        }
                    ],
                    dateCreate: null,
                    dateLastChange: null,
                    like: 0,
                    position: num - 1,
                    leagueItem: null,
                    citiesBlock: null,
                    orderList: null,
                    historyList: null,
                    geozoneBlock: null,
                    specBlock: null,
                    useRating: useRating,
                    isRibbon: isRibbon
                }); });
            }
            var userid = localStorage.getItem('userId');
            dispatch({
                type: ADD_MANY_LR_POST_TIMEOUT_START,
                payload: {
                    data: longReadLoadingPosts,
                    lgId: lgid,
                    reverseParam: reverseParam
                }
            });
            (generalProps === null || generalProps === void 0 ? void 0 : generalProps.performerByEventOrByTimeout) && generalProps.performerByEventOrByTimeout(function () {
                var _a;
                getLongReadPosts(userid, lgid, ((_a = generalProps === null || generalProps === void 0 ? void 0 : generalProps.commonProps) === null || _a === void 0 ? void 0 : _a.sign) || '', thematic)(dispatch);
                dispatch({
                    type: ADD_MANY_LR_POST_TIMEOUT_END,
                    payload: {
                        data: null,
                        lgId: lgid
                    }
                });
            }, res, 8000);
        };
        var onError = function (err) {
            dispatch({
                type: ADD_LR_POST_ERROR,
                payload: {
                    lgId: lgid
                }
            });
        };
        urlApi()
            .addManyLongReadPost(imageList, id, lgid, isFL, title, text, color, num, thematic, onAfterLoad, style, caption, titlePosition, anchorText, useRating, onSubmit, onError, isRibbon, additionalInfo);
    };
}
//# sourceMappingURL=addLongReadPost.js.map